import type { Note } from "@adafia/types";

export interface FileNode extends Note {
	id: string; // Ensure id is required in the tree structure
	children?: FileNode[];
}

/**
 * Builds a hierarchical tree structure from a flat list of nodes.
 */
export const buildTree = (nodes: Note[]): FileNode[] => {
	const map = new Map<string, FileNode>();
	for (const node of nodes) {
		if (node.id) map.set(node.id, { ...node, id: node.id, children: [] });
	}

	const roots: FileNode[] = [];
	for (const node of nodes) {
		const item = node.id ? map.get(node.id) : null;
		if (!item) continue;

		const parent = node.parentId ? map.get(node.parentId) : null;
		if (parent) {
			parent.children?.push(item);
		} else {
			roots.push(item);
		}
	}

	return roots;
};
